const BASE32 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';

export const E2E_TEST_ID_TAG = 'E2E';
const E2E_TEST_RUN_LENGTH = 3;
// 5 znaków (32^5 ≈ 33M) zamiast 3, bo run ID jest stały w obrębie przebiegu —
// przy 3 znakach kolizje ID gier między testami zdarzały się co kilkadziesiąt przebiegów.
const E2E_GAME_ID_SUFFIX_LENGTH = 5;
export const E2E_DEBUG_TAG = 'e2e-test-data';

function randomBase32(length: number): string {
  let value = '';
  for (let index = 0; index < length; index += 1) {
    value += BASE32[Math.floor(Math.random() * BASE32.length)];
  }
  return value;
}

export function normalizeE2ETestRunId(raw?: string | null): string | null {
  if (!raw) return null;
  const normalized = raw
    .trim()
    .toUpperCase()
    .replace(/[^A-Z2-7]/g, '');
  if (normalized.length < E2E_TEST_RUN_LENGTH) return null;
  return normalized.slice(0, E2E_TEST_RUN_LENGTH);
}

function readImportMetaRunId(): string | null {
  if (typeof import.meta === 'undefined') return null;
  return normalizeE2ETestRunId(import.meta.env?.VITE_E2E_TEST_RUN_ID);
}

function readProcessRunId(): string | null {
  if (typeof process === 'undefined') return null;
  return normalizeE2ETestRunId(
    process.env?.PW_E2E_RUN_ID
    || process.env?.VITE_E2E_TEST_RUN_ID
  );
}

function isVitestRuntime(): boolean {
  if (typeof process !== 'undefined' && process.env?.VITEST) return true;
  if (typeof import.meta !== 'undefined' && import.meta.env?.MODE === 'test') return true;
  return false;
}

function readConfiguredE2ETestRunId(): string | null {
  return readImportMetaRunId() || readProcessRunId();
}

export function shouldUseE2ETestMarker(options?: { force?: boolean }): boolean {
  if (options?.force) return true;
  if (isVitestRuntime()) return false;
  return Boolean(readConfiguredE2ETestRunId());
}

function createE2ETestIdPrefix(options?: { force?: boolean }): string | null {
  if (!shouldUseE2ETestMarker(options)) return null;
  const runId = readConfiguredE2ETestRunId() || randomBase32(E2E_TEST_RUN_LENGTH);
  return `${E2E_TEST_ID_TAG}${runId}`;
}

export function createE2ETestGameId(options?: { force?: boolean }): string {
  const prefix = createE2ETestIdPrefix(options);
  if (!prefix) {
    throw new Error('E2E test marker requested outside E2E runtime');
  }
  return `${prefix}-${randomBase32(E2E_GAME_ID_SUFFIX_LENGTH)}`;
}

export function createE2EDebugTag(runId?: string | null): string {
  const normalized = normalizeE2ETestRunId(runId) || readConfiguredE2ETestRunId() || randomBase32(E2E_TEST_RUN_LENGTH);
  return `e2e:${normalized}`;
}
